"use strict";

var _objectSpread = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _toConsumableArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _asyncToGenerator = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.watchWorker = void 0;
var mobx_state_tree_1 = require("mobx-state-tree");
var util_1 = require("../util");
var remoteAbortSignals_1 = require("./remoteAbortSignals");
var configuration_1 = require("../configuration");
function isClonable(thing) {
  if (typeof thing === 'function') {
    return false;
  }
  if (thing instanceof Error) {
    return false;
  }
  return true;
}
// watches the given worker object, returns a promise that will be rejected if
// the worker times out
function watchWorker(_x, _x2, _x3) {
  return _watchWorker.apply(this, arguments);
}
function _watchWorker() {
  _watchWorker = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(worker, pingTime, rpcDriverClassName) {
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          if (!true) {
            _context5.next = 7;
            break;
          }
          _context5.next = 3;
          return worker.call('ping', [], {
            timeout: pingTime * 2,
            rpcDriverClassName: rpcDriverClassName
          });
        case 3:
          _context5.next = 5;
          return new Promise(function (resolve) {
            return setTimeout(resolve, pingTime);
          });
        case 5:
          _context5.next = 0;
          break;
        case 7:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _watchWorker.apply(this, arguments);
}
exports.watchWorker = watchWorker;
function detectHardwareConcurrency() {
  var mainThread = typeof window !== 'undefined';
  var canDetect = mainThread && 'hardwareConcurrency' in window.navigator;
  if (mainThread && canDetect) {
    return window.navigator.hardwareConcurrency;
  }
  return 1;
}
var LazyWorker = /*#__PURE__*/function () {
  function LazyWorker(driver) {
    _classCallCheck(this, LazyWorker);
    this.driver = driver;
  }
  _createClass(LazyWorker, [{
    key: "getWorker",
    value: function () {
      var _getWorker = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this = this;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!this.workerP) {
                this.workerP = this.driver.makeWorker().then(function (worker) {
                  watchWorker(worker, _this.driver.maxPingTime, _this.driver.name).catch(function (error) {
                    if (worker) {
                      console.error('worker did not respond, killing and generating new one');
                      console.error(error);
                      worker.destroy();
                      worker.status = 'killed';
                      worker.error = error;
                      _this.workerP = undefined;
                    }
                  });
                  return worker;
                }).catch(function (e) {
                  _this.workerP = undefined;
                  throw e;
                });
              }
              return _context.abrupt("return", this.workerP);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getWorker() {
        return _getWorker.apply(this, arguments);
      }
      return getWorker;
    }()
  }]);
  return LazyWorker;
}();
var BaseRpcDriver = /*#__PURE__*/function () {
  function BaseRpcDriver(args) {
    _classCallCheck(this, BaseRpcDriver);
    this.lastWorkerAssignment = -1;
    this.workerAssignments = new Map(); // sessionId -> worker number
    this.maxPingTime = 30000;
    this.workerCheckFrequency = 5000;
    this.config = args.config;
  }
  // filter the given object and just remove any non-clonable things from it
  _createClass(BaseRpcDriver, [{
    key: "filterArgs",
    value: function filterArgs(thing, sessionId) {
      var _this2 = this;
      if (Array.isArray(thing)) {
        return thing.filter(isClonable).map(function (t) {
          return _this2.filterArgs(t, sessionId);
        });
      }
      if (typeof thing === 'object' && thing !== null) {
        // AbortSignals are specially handled
        if (thing instanceof AbortSignal) {
          return (0, remoteAbortSignals_1.serializeAbortSignal)(thing, this.remoteAbort.bind(this, sessionId));
        }
        if ((0, mobx_state_tree_1.isStateTreeNode)(thing) && !(0, mobx_state_tree_1.isAlive)(thing)) {
          throw new Error('dead state tree node passed to RPC call');
        }
        // special case, don't try to iterate the file's subelements as the
        // object entries below would
        if (thing instanceof File) {
          return thing;
        }
        return Object.fromEntries(Object.entries(thing).filter(function (e) {
          return isClonable(e[1]);
        }).map(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
            k = _ref2[0],
            v = _ref2[1];
          return [k, _this2.filterArgs(v, sessionId)];
        }));
      }
      return thing;
    }
  }, {
    key: "remoteAbort",
    value: function () {
      var _remoteAbort = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(sessionId, functionName, signalId) {
        var worker;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.getWorker(sessionId);
            case 2:
              worker = _context2.sent;
              _context2.next = 5;
              return worker.call(functionName, {
                signalId: signalId
              }, {
                timeout: 1000000,
                rpcDriverClassName: this.name
              });
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function remoteAbort(_x4, _x5, _x6) {
        return _remoteAbort.apply(this, arguments);
      }
      return remoteAbort;
    }()
  }, {
    key: "createWorkerPool",
    value: function createWorkerPool() {
      var _this3 = this;
      var hardwareConcurrency = detectHardwareConcurrency();
      var workerCount = (0, configuration_1.readConfObject)(this.config, 'workerCount') || (0, util_1.clamp)(1, Math.max(1, hardwareConcurrency - 1), 5);
      return _toConsumableArray(new Array(workerCount)).map(function () {
        return new LazyWorker(_this3);
      });
    }
  }, {
    key: "getWorkerPool",
    value: function getWorkerPool() {
      if (!this.workerPool) {
        var res = this.createWorkerPool();
        this.workerPool = res;
        return res; // making this several steps makes TS happy
      }

      return this.workerPool;
    }
  }, {
    key: "getWorker",
    value: function () {
      var _getWorker2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(sessionId) {
        var workers, workerNumber, workerAssignment, worker;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              workers = this.getWorkerPool();
              workerNumber = this.workerAssignments.get(sessionId);
              if (workerNumber === undefined) {
                workerAssignment = (this.lastWorkerAssignment + 1) % workers.length;
                this.workerAssignments.set(sessionId, workerAssignment);
                this.lastWorkerAssignment = workerAssignment;
                workerNumber = workerAssignment;
              }
              // console.log(`${sessionId} -> worker ${workerNumber}`)
              worker = workers[workerNumber].getWorker();
              if (worker) {
                _context3.next = 6;
                break;
              }
              throw new Error('no web workers registered for RPC');
            case 6:
              return _context3.abrupt("return", worker);
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getWorker(_x7) {
        return _getWorker2.apply(this, arguments);
      }
      return getWorker;
    }()
  }, {
    key: "call",
    value: function () {
      var _call = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(pluginManager, sessionId, functionName, args) {
        var _this4 = this;
        var options,
          done,
          worker,
          rpcMethod,
          serializedArgs,
          filteredAndSerializedArgs,
          callP,
          killedCheckInterval,
          killedP,
          resultP,
          _args4 = arguments;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              options = _args4.length > 4 && _args4[4] !== undefined ? _args4[4] : {};
              if (sessionId) {
                _context4.next = 3;
                break;
              }
              throw new TypeError('sessionId is required');
            case 3:
              done = false;
              _context4.next = 6;
              return this.getWorker(sessionId);
            case 6:
              worker = _context4.sent;
              rpcMethod = pluginManager.getRpcMethodType(functionName);
              _context4.next = 10;
              return rpcMethod.serializeArguments(args, this.name);
            case 10:
              serializedArgs = _context4.sent;
              filteredAndSerializedArgs = this.filterArgs(serializedArgs, sessionId); // now actually call the worker
              callP = worker.call(functionName, filteredAndSerializedArgs, _objectSpread({
                timeout: 5 * 60 * 1000,
                statusCallback: args.statusCallback,
                rpcDriverClassName: this.name
              }, options)).finally(function () {
                done = true;
              }); // check every 5 seconds to see if the worker has been killed, and
              // reject the killedP promise if it has
              killedP = new Promise(function (resolve, reject) {
                killedCheckInterval = setInterval(function () {
                  // must've been killed
                  if (worker.status === 'killed') {
                    reject(new Error("operation timed out, worker process stopped responding, ".concat(worker.error)));
                  } else if (done) {
                    resolve(true);
                  }
                }, _this4.workerCheckFrequency);
              }).finally(function () {
                clearInterval(killedCheckInterval);
              }); // the result is a race between the actual result promise, and the "killed"
              // promise. the killed promise will only actually win if the worker was
              // killed before the call could return
              resultP = Promise.race([callP, killedP]);
              return _context4.abrupt("return", rpcMethod.deserializeReturn(resultP, args, this.name));
            case 16:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function call(_x8, _x9, _x10, _x11) {
        return _call.apply(this, arguments);
      }
      return call;
    }()
  }]);
  return BaseRpcDriver;
}();
exports.default = BaseRpcDriver;